// extracted by mini-css-extract-plugin
export var createdDate = "_lh-1";
export var divider = "_lh-2";
export var headerDivider = "_lh-3";
export var messagesCard = "_lh-0";
export var messagesContainer = "_lh-6";
export var messagesContainerWrapper = "_lh-4";
export var showLeftPanelButton = "_lh-8";
export var topButtons = "_lh-7";
export var withPadding = "_lh-5";